/* eslint tailwindcss/no-custom-classname: off */
import { NextSeo } from 'next-seo'
import { SummaryDetailResponse } from '@/types/summary'
import { useBreadcrumb } from '@/hooks/useBreadcrumb'
import { Author, Calligraphy, Property } from '.'
import { Genre, Price, Publisher, Release } from '.'
import { useState } from 'react'
import { AuthorDetail, Body, Important, Notation, Review } from '.'
import { useFooter } from '@/hooks/useFooter'
import { H1 } from '@/components/label'
import { SubTitle } from './'
import { BooksellerRegist } from './BooksellerRegist'

interface Props {
  summaryDetail: SummaryDetailResponse
}

export const SummaryDetailForBooksellerPage: React.FC<Props> = ({
  summaryDetail,
}) => {
  useBreadcrumb(null)
  useFooter(false)
  const [open, setOpen] = useState(false)
  const { summary } = summaryDetail
  const { title, subtitle, subpos } = summary
  return (
    <>
      <NextSeo
        title={`${summary.title} ${
          summary.subtitle ? `/ ${summary.subtitle} ` : ''
        } | 本の要約サイト flier(フライヤー)`}
        description={summary.review.slice(0, 100)}
        openGraph={{
          images: [
            {
              url: `${process.env.IMG_SERVER}/summary/${summary.id}_cover_300.jpg`,
              width: 1200,
              height: 630,
            },
          ],
        }}
      />
      <BooksellerRegist />
      {/* SP表示 */}
      <div className="p-2 sp">
        <div className="flex w-full">
          {/** 書影部分 */}
          <Calligraphy id={summary.id} title={summary.title} />
          <div className="flex-2">
            {summary.subpos == 1 && (
              <div className="text-sm">{summary.subtitle}</div>
            )}
            <div className="text-xl font-medium">{summary.title}</div>
            {summary.subpos == 2 && (
              <div className="text-sm">{summary.subtitle}</div>
            )}
            <div className="pt-5">
              <Author authors={summary.authors} showBorder={false} />
            </div>
          </div>
        </div>
        <div className="px-[10px] mb-[30px]">
          {open ? (
            <div
              className="flex-1 text-[15px] leading-9"
              onClick={() => setOpen(false)}
            >
              <Genre categories={summary.categories} />
              <Publisher
                name={summary.publisher.name}
                link={summary.publisher_link}
              />
              <Price price={summary.price} />
              <Release date={summary.release} />
            </div>
          ) : (
            <div className="relative py-2 pb-[10px] my-2 align-top border-t border-b">
              <div
                className="after:absolute after:top-[10px] after:right-[10px] after:text-4xl after:leading-4 after:text-[#50608b] after:content-['+']"
                onClick={() => setOpen(true)}
              >
                書籍情報を見る
              </div>
            </div>
          )}
        </div>
      </div>

      {/* PC表示 */}
      <div className="my-0 mx-auto w-[716px] pc">
        {subtitle && subpos === 1 && (
          <SubTitle text={subtitle} className="mt-6" />
        )}
        <H1
          title={title}
          className={`min-h-[50px] text-4xl ${subpos === 2 ? 'mt-5' : ''}`}
          showShadowTitle={false}
        />
        {subtitle && subpos === 2 && <SubTitle text={subtitle} />}
      </div>
      <div className="my-6 w-full border-b"></div>
      <div className="flex justify-center my-0 mx-auto w-[716px] pc">
        <Calligraphy id={summary.id} title={summary.title} />
        <Property summary={summary} />
      </div>
      <div className="flex justify-center">
        <div className="mr-0 sm:mr-[30px] mb-[50px] w-full sm:w-[716px] h-auto sm:h-full text-[17px] align-top">
          <Review review={summary.review} writer={summary.writer} />
          <AuthorDetail title="著者" body={summary.about_author} />
          <Important important={summary.important} />
          <Body title="要約" body={summary.body} />
          <Notation title="一読のすすめ" body={summary.notation} />
        </div>
      </div>
      <BooksellerRegist />
      <div className="py-6 mt-12 w-full text-sm text-center text-white bg-[#31333d]">
        Copyright &copy; Flier Inc. all rights reserved.
      </div>
    </>
  )
}
